import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { ChangeContributionsForm } from './components/ChangeContributionForm';
import { useModifyContributions } from './hooks/useModifyContributions';

export const ModifyContributions: React.FC = () => {
	const {
		data: { title, subtitle, isSupportedCountry, updateContributionSubtitle },
	} = useModifyContributions();

	return (
		<div className="flex flex-col gap-4">
			<div className="flex flex-col gap-2">
				<Text as="h2" size="x-small" variant="heading" fontWeight="bold">
					{title}
				</Text>

				<Text className="mt-2" as="p" data-qa="current-contribution-info">
					{subtitle}
				</Text>

				<Text as="p" data-qa="update-contribution-info">
					{updateContributionSubtitle}
				</Text>
			</div>

			{isSupportedCountry && <ChangeContributionsForm />}
		</div>
	);
};
